(function () {
  function init(container) {
    var form = container.closest('.card') && container.closest('.card').querySelector('form.product-form');
    var sourceButton = form && form.querySelector('.product-form__add-button');
    var stickyButton = container.querySelector('[data-mobile-sticky-atc-button]');
    var paymentContainer = form && form.querySelector('.product-form__payment-container');
    if (!form || !sourceButton || !stickyButton || !paymentContainer) return;

    var sync = function () {
      stickyButton.disabled = sourceButton.disabled;
      stickyButton.textContent = sourceButton.textContent.trim();
    };
    var setVisible = function (visible) {
      var shouldShow = visible && !sourceButton.disabled;
      container.hidden = !shouldShow;
      container.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.documentElement.classList.toggle('mobile-sticky-atc-visible', shouldShow);
    };

    sync();
    stickyButton.addEventListener('click', function () {
      if (!sourceButton.disabled) sourceButton.click();
    });
    form.addEventListener('change', sync);
    new MutationObserver(sync).observe(sourceButton, { attributes: true, childList: true, subtree: true });

    if (!window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function (entries) {
      setVisible(!entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(paymentContainer);
  }

  function start() {
    document.querySelectorAll('[data-mobile-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
